import { render } from "./wishlistedArticle.vue?vue&type=template&id=4a080e3c&scoped=true"
import script from "./wishlistedArticle.vue?vue&type=script&lang=js"
export * from "./wishlistedArticle.vue?vue&type=script&lang=js"

import "./wishlistedArticle.vue?vue&type=style&index=0&id=4a080e3c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a080e3c"]])

export default __exports__